import Vue from 'vue'
import Vuex from 'vuex'
import API from '../apis'
import { redirectLogin, verifyIsWb } from '../utils/oa'
import { getToken, getEmail } from '../utils/user'
import { Message } from 'element-ui'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: getEmail(),
    email: '',
    userinfo: {},
    isWb: verifyIsWb(getEmail() || ''),
    isLogin: !!getToken(),
    auditInfo: {
      auditUserList: [],
      count: 0
    }
  },
  mutations: {
    LOGIN (state, payload) {
      state.isLogin = true
      const { email, username } = payload
      state.username = username
      state.email = email
      this.dispatch('graphqlUserinfo')
    }
  },
  actions: {
    async init () {
      // 登录
      let sid = window.location.search.match(/sid=([^&]+)/)

      if (sid) {
        await this.dispatch('login', sid[1])
      } else {
        await this.dispatch('getUserinfo')
      }

      await this.dispatch('graphqlUserinfo')
    },
    getUserinfo ({ state }) {
      return API.getUserinfo().then(res => {
        state.username = res.username
        state.email = res.uid
        state.isLogin = true
      })
    },
    async login ({ state }, sid) {
      try {
        let res = await API.login({ sid })
        let token = res.token
        state.username = res.username
        state.email = res.email
        state.isLogin = true
        window.localStorage.setItem('__soa_token__', token)
      } catch (err) {
        // alert(err.msg || err.message)
        Message({
          showClose: true,
          message: err.msg || err.message,
          type: 'error'
        })
        if (err.ret === 4001002) {
          redirectLogin()
        }
      }
    },
    async graphqlUserinfo ({ state }) {
      if (!state.email) {
        return
      }

      try {
        // const type = verifyIsWb(state.email) ? 'wbUser' : 'user'
        const type = 'user'
        let res = await API.graphql({
          query: `
            query {
              ${type} (email: "${state.email}") {
                credits
                department_id
                department {
                  name
                  parent_id
                  parent_department_info {
                    name
                  }
                }
              }
            }
          `
        })

        state.userinfo = res.data[type]
      } catch (err) {
        if (err.message && err.message.indexOf('401') !== -1) {
          redirectLogin()
          // return
        }
        // alert('非常抱歉，该用户还未录入系统。请联系HR添加~')
      }
    },
    async graphaqlAuditInfo ({ state }) {
      if (!state.email) {
        return
      }

      const auditUserRes = await API.graphql({
        query: `
          query {
            auditUserList(email: "${state.email}", status: 1) {
              rows {
                id
                type
                department_id
                department {
                  name
                  credits
                }
              }
            }
          }
        `
      })

      state.auditInfo.auditUserList = auditUserRes.data.auditUserList.rows
      const auditUserId = state.auditInfo.auditUserList.map(item => item.id)
      const STATUS_WAIT = 1

      const recordListRes = await API.graphql({
        query: `
          query {
            auditRecordList(audit_user: [${auditUserId}], status: [${STATUS_WAIT}]) {
              count
            }
          }
        `
      })

      state.auditInfo.count = recordListRes.data.auditRecordList.count
    }
  },
  modules: {
  }
})
